<div class="bmc-sap-cp-connector-container">
  <biz-sap-config-list
    [connectors]="sapConfigurations"
    [selectedConnector]="selectedConfig"
    [isLoading]="isLoading"
    (onSelectConnector)="applySelectConnector($event)">
  </biz-sap-config-list>

  <biz-sap-config-detail *ngIf="selectedConfig" (cancelAction)="cancelAction()"
                         [sapConfiguration]="selectedConfig"></biz-sap-config-detail>
  <div class="bmc-sap-cp-connector-container__empty"
       *ngIf="sapConfigurations && sapConfigurations.length > 0&& !selectedConfig">
    <h3>{{'EXCEL_CONNECTOR.SELECT_A_CONNECTOR' | translate}}</h3>
  </div>

  <div class="bmc-sap-cp-connector-container__empty" *ngIf="!sapConfigurations && !selectedConfig">
    <h3>{{'EXCEL_CONNECTOR.EMPTY' | translate}}</h3>
  </div>
</div>
